import React, { FC } from 'react';
import { STEP_OR_SEPARATOR } from '../constants';

interface StepDescriptionProps {
  text: string;
}

export const StepDescription: FC<StepDescriptionProps> = ({ text }) => {
  const hasOr = STEP_OR_SEPARATOR.test(text);
  const parsedParts = hasOr
    ? text
        .split(STEP_OR_SEPARATOR)
        .map((part) => part.trim())
        .filter(Boolean)
    : [text];
  const parts = parsedParts.length ? parsedParts : [text];

  if (!hasOr || parts.length < 2) {
    return <p className="itv-static-landing__step-text">{text}</p>;
  }

  return (
    <div className="itv-static-landing__step-text itv-static-landing__step-text--with-or">
      <div className="itv-static-landing__step-options">
        {parts.map((part, index) => (
          <React.Fragment key={`${part}-${index}`}>
            {index > 0 && <span className="itv-static-landing__step-divider">OR</span>}
            <p className="itv-static-landing__step-option">{part}</p>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
